module.exports = __webpack_public_path__ + "media/icons/message-8a9210f9.png";